import { Route } from '@angular/router';
import { MasterDataCountriesComponent } from './countries/master-data-countries.component';
import { CatalogGridComponent } from './catalog/catalog-grid/catalog-grid.component';
import { TemplatesGridComponent } from './catalog/templates-grid/templates-grid.component';
import { MasterDataPlanComponent } from './plans/master-data-plans.component';
import { MasterDataUsersComponent } from './users/master-data-users.component';
import { authGuard } from '@doka/identity-login';
import { MasterDataCurrenciesComponent } from './currencies/master-data-currencies.component';

export const masterDataRoutes: Route = {
  loadComponent: () => import('./master-data.page').then((m) => m.MasterDataPage),
  children: [
    {
      path: '',
      redirectTo: 'catalog',
      pathMatch: 'full',
    },
    {
      path: 'catalog',
      component: CatalogGridComponent,
      canActivate: [authGuard],
    },
    {
      path: 'catalog/:catalogItemId',
      component: TemplatesGridComponent,
      canActivate: [authGuard],
    },
    { path: 'countries', component: MasterDataCountriesComponent, canActivate: [authGuard] },
    { path: 'currencies', component: MasterDataCurrenciesComponent, canActivate: [authGuard] },
    { path: 'plans', component: MasterDataPlanComponent, canActivate: [authGuard] },
    { path: 'users', component: MasterDataUsersComponent, canActivate: [authGuard] },
    { path: '**', redirectTo: 'catalog' },
  ],
};
